module.exports = __webpack_public_path__ + "img/bjinformation2.1abce5a2.png";